var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-trackvideo-card--sleep"},[_vm._v(_vm._s(_vm.$t('trackVideo.state.sleep', { seconds: _vm.seconds })))])
}
var staticRenderFns = []

export { render, staticRenderFns }